let pathname = location.pathname;
pathname = pathname.slice(1)
pathname = pathname.split('/')[0]
console.log(pathname)
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    if(pathname=='mall'){
        pathname='home'
    }
    location.href = 'https://m.colofoo.com/#/' + pathname;
}

